import { ImageScaleView, View } from '@play-co/timestep-core/ui';
import { Container } from '../../../odie';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';
import {
  FlowerFidgetBlockProps,
  FlowerFidgetState,
  flowerFidgetColors,
} from './FlowerFidgetBlock';
import { SpineView, spineLoader } from '@play-co/timestep-spine';
import { playSpineAnimation, setSpineAttachment } from 'src/lib/ui/utils/spine';

export const flowerFidgetSpine = {
  loadMethod: spineLoader,
  url: getMatch2AssetPath('blocks/flowerFidget/animation/spine.fidgetspinner'),
};

export class FlowerFidgetBlockView extends Container {
  public spine?: SpineView;

  constructor(props: FlowerFidgetBlockProps) {
    super();
    blockPositionView(this, props);
    this.createSpine();
  }

  private async createSpine() {
    if (this.spine) return;
    await spineLoader(flowerFidgetSpine.url);
    this.spine = new SpineView({
      superview: this.view,
      spinePath: flowerFidgetSpine.url,
      scale: 0.6,
    });
    playSpineAnimation(this.spine, { animation: 'idle', loop: true });
  }

  public static assets() {
    return [flowerFidgetSpine];
  }

  public updateColors(state: FlowerFidgetState) {
    if (!this.spine) return;
    for (const color of flowerFidgetColors) {
      const hit = state[color];
      setSpineAttachment(this.spine, {
        slot: `empty_${color}`,
        attachment: hit ? `fill_${color}` : `empty_${color}`,
      });
    }
  }

  public async playHitAnimation() {
    if (!this.spine) return;
    await playSpineAnimation(this.spine, {
      animation: 'blockspin',
      loop: false,
    });
    playSpineAnimation(this.spine, { animation: 'idle', loop: true });
  }
}

export function _createFlowerFidgetBlockView(
  props: FlowerFidgetBlockProps,
): FlowerFidgetBlockView {
  return new FlowerFidgetBlockView(props);
}
